import React from 'react'
import { useTranslation } from 'react-i18next'
import { BaseView } from '@/components/base'
import { Modal } from '@/components/Modal'
import { AppButton } from '@/components/AppButton'
import { Label } from '@/features/dashboard/components/DashboardHeader/components/Profile/components/Label'

interface RecoverPasswordAndUpdateEmailProps {
  type?: 'recoverPassword' | 'updateEmail'
  receiveCodeByPhoneNumber: () => void
  receiveCodeByEmail: () => void
  isOpen: boolean
  onClose: () => void
}

export const RecoverPasswordAndUpdateEmailBottomSheet: React.FC<
  RecoverPasswordAndUpdateEmailProps
> = ({
  type = 'recoverPassword',
  receiveCodeByPhoneNumber,
  receiveCodeByEmail,
  isOpen,
  onClose,
}) => {
  const { t } = useTranslation()
  const title = t(
    type === 'recoverPassword'
      ? 'bottomSheets:recoverPasswordAndUpdateEmail.titleForgotPassword'
      : 'bottomSheets:recoverPasswordAndUpdateEmail.titleUpdateEmail',
  )
  const subTitle = t(
    type === 'recoverPassword'
      ? 'bottomSheets:recoverPasswordAndUpdateEmail.descriptionForgotPassword'
      : 'bottomSheets:recoverPasswordAndUpdateEmail.descriptionUpdateEmail',
  )
  return (
    <Modal isOpen={isOpen} onClose={onClose} showHandle={true}>
      <BaseView
        style={{
          gap: 12,
          paddingBottom: 20,
          scrollbarWidth: 'none',
        }}
      >
        <div className="flex flex-col flex-1 px-3 py-8">
          <div
            className={`flex flex-col gap-4 ${
              type === 'updateEmail' ? 'px-4' : ''
            }`}
          >
            <Label type="titleBottomSheet" centralize>
              {title}
            </Label>
            <Label type="descriptionBottomSheet" centralize>
              {subTitle}
            </Label>
          </div>

          <div className="flex flex-row items-center justify-between gap-3 mt-[20%]">
            <AppButton
              onClick={receiveCodeByPhoneNumber}
              type="purpleGradientWithContour"
              isSharedSpace
              label={t('translation:phone')}
            />

            <AppButton
              onClick={receiveCodeByEmail}
              isSharedSpace
              label={t('translation:email')}
            />
          </div>
        </div>
      </BaseView>
    </Modal>
  )
}

export default RecoverPasswordAndUpdateEmailBottomSheet
